// Row ordering for the Masking / Encryption tables: sort by when each source's most recent
// job was run, newest first, so a just-started job sits at the top of the first page and stays
// there until another job is run (a later start time bumps it up). Sources that have never run
// a job sink to the bottom.

// Numeric ms timestamp for when a masking/encrypt/decrypt job was run. Prefers the start/submit
// time over the finish time so a just-started (still-running) job orders by when it kicked off,
// and its slot doesn't shift once it completes.
export function jobTimestampMs(job) {
  if (!job) return null;
  const candidates = [job.startedAt, job.submittedAt, job.finishedAt];
  for (const v of candidates) {
    if (v == null || v === '') continue;
    const ms = typeof v === 'number' ? v : Date.parse(v);
    if (!Number.isNaN(ms) && ms > 0) return ms;
  }
  return null;
}

// Comparator over source rows carrying a `latestJobAt` (ms, or null). Newest job first; no-job
// rows last. Name tiebreak keeps the order stable across polling refreshes.
export function compareByLatestJobDesc(a, b) {
  const ta = (a && a.latestJobAt) || 0;
  const tb = (b && b.latestJobAt) || 0;
  if (tb !== ta) return tb - ta;
  return String((a && a.connection_name) || '').localeCompare(String((b && b.connection_name) || ''));
}
